function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 27,
    style: {
      fill: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 19.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 3h-4.755L20.385.975A2.986 2.986 0 0 0 18.18 0h-6.36c-.84 0-1.65.36-2.22.975L7.755 3H3C1.35 3 0 4.35 0 6v18c0 1.65 1.35 3 3 3h24c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3zM15 22.5c-4.14 0-7.5-3.36-7.5-7.5 0-4.14 3.36-7.5 7.5-7.5 4.14 0 7.5 3.36 7.5 7.5 0 4.14-3.36 7.5-7.5 7.5z",
    style: {
      fill: "#404040"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.537a182f04fe398979cafba6c931810c.svg";
export { ForwardRef as ReactComponent };